// extracted by mini-css-extract-plugin
module.exports = {"image-slider":"_39H4w","dot-wrapper":"_3F0nT","content":"_2kTDH","dot-slider":"_33bzo","slide-arrow":"Tq-tX","left":"nauNA","right":"_9vdGE"};